import React, { memo } from 'react';
import { Globe } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const LanguageSelector = memo(() => {
  const { i18n } = useTranslation();

  const handleLanguageChange = (e) => {
    i18n.changeLanguage(e.target.value);
  };

  return (
    <div className="absolute top-4 right-4 z-50">
      <div className="flex items-center gap-2 bg-white/90 backdrop-blur-sm rounded-lg shadow-lg px-3 py-2">
        <Globe size={18} className="text-emerald-600" />
        <select
          value={i18n.language}
          onChange={handleLanguageChange}
          className="bg-transparent border-none outline-none cursor-pointer text-sm font-medium text-gray-700"
        >
          <option value="fi">Suomi</option>
          <option value="en">English</option>
          <option value="sv">Svenska</option>
          <option value="fr">Français</option>
        </select>
      </div>
    </div>
  );
});

LanguageSelector.displayName = 'LanguageSelector';

export default LanguageSelector;